export default __webpack_public_path__ + "static/media/bu-isna.824d9f40.png";